import React, { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import { CountdownTimerRef } from '../models';

const CountdownTimer = forwardRef<CountdownTimerRef, { submitDisabled: boolean; submitSix: () => void; matchId?: number }>(
	({ submitDisabled, submitSix, matchId }, ref) => {
		const [timers, setTimers] = useState<Record<number, number>>({});
		const intervalRefs = useRef<Record<number, any>>({});

		useImperativeHandle(ref, () => ({
			startTimer: (duration: number, id: number) => {
				setTimers((prev) => ({ ...prev, [id]: duration }));
				if (intervalRefs.current[id]) clearInterval(intervalRefs.current[id]);

				intervalRefs.current[id] = setInterval(() => {
					setTimers((prev) => {
						const currentTime = prev[id];
						if (currentTime <= 1) {
							clearInterval(intervalRefs.current[id]);
							const newTimers = { ...prev };
							delete newTimers[id];
							return newTimers;
						}
						return { ...prev, [id]: currentTime - 1 };
					});
				}, 1000);
			},
			stopTimer: (id: number) => {
				if (intervalRefs.current[id]) {
					clearInterval(intervalRefs.current[id]);
				}
				setTimers((prev) => {
					const newTimers = { ...prev };
					delete newTimers[id];
					return newTimers;
				});
			},
			isRunning: (id: number) => !!timers[id],
			getTimeLeft: (id: number) => timers[id] || 0
		}));

		const currentTimeLeft = matchId ? timers[matchId] : 0;

		return (
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
				<button
					type='button'
					disabled={submitDisabled || currentTimeLeft > 0}
					onClick={submitSix}
					style={{
						padding: '12px 24px',
						backgroundColor: '#276EF1',
						color: 'white',
						border: 'none',
						borderRadius: '4px',
						cursor: submitDisabled || currentTimeLeft > 0 ? 'not-allowed' : 'pointer',
						fontSize: '14px',
						fontWeight: 500,
						opacity: submitDisabled || currentTimeLeft > 0 ? 0.5 : 1
					}}>
					Register Super Six
				</button>
				{currentTimeLeft > 0 && (
					<div>
						Please wait for <span style={{ fontWeight: 600 }}>{currentTimeLeft} seconds</span> before registering another
						six
					</div>
				)}
			</div>
		);
	}
);

export default CountdownTimer;
